var map = {
	"./arrow-right.png": 1961,
	"./backgroundMainCategory.svg": 4180,
	"./backgroundNoItems.png": 2868,
	"./barcelona.png": 2996,
	"./bayern.png": 2838,
	"./bg-texture.png": 1340,
	"./clubs/barca-mono.png": 2776,
	"./clubs/bayern-mono.png": 7330,
	"./clubs/city-mono.png": 5202,
	"./clubs/inter-mono.png": 3919,
	"./clubs/milan-mono.png": 2284,
	"./clubs/real-mono.png": 665,
	"./clubs/united-mono.png": 2722,
	"./england.png": 1544,
	"./france.png": 6546,
	"./germany.png": 8808,
	"./gift-card-2.png": 6251,
	"./gift-card-back.png": 9776,
	"./gift-card-t.png": 5789,
	"./gift-card.png": 626,
	"./italy.png": 4250,
	"./leagues/england.png": 6071,
	"./leagues/france.png": 9791,
	"./leagues/germany.png": 659,
	"./leagues/italy.png": 4181,
	"./leagues/spain.png": 4559,
	"./main-banner-add1.png": 8570,
	"./main-banner-add2.png": 3329,
	"./main-banner-add3.png": 9464,
	"./main-banner-add4.png": 9079,
	"./main-banner-add5.png": 6590,
	"./main-banner-add6.png": 2341,
	"./main-banner-add7.png": 6428,
	"./main-banner.png": 2649,
	"./manchester-city.png": 53,
	"./manchester-united.png": 3337,
	"./new-shirt-category.png": 2601,
	"./real-madrid.png": 8789,
	"./retro-category.png": 5274,
	"./spain.png": 7864,
	"./texture-footer.png": 500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;